import React from 'react';
import { Item } from 'semantic-ui-react'
import {useTranslation} from "react-i18next";

function Recent() {
  const { t } = useTranslation(["page-games", "general"]);

  const items = [
    {
      childKey: 2,
      image: '/Games/Woodo.png',
      header: 'Woodo',
      description: '',
      content: <p>{t('french-translation')} + {t('french-studio')}<br/>{t('translation-coordination', {'languages': '$t(general:language.korean) / $t(general:language.spanish) / $t(general:language.latam) / $t(general:language.polish) / $t(general:language.portuguese-brazil) / $t(general:language.czech)'})}</p>,
      meta: '2026',
    },
    {
      childKey: 3,
      image: '/Games/GraveyardKeeper2.png',
      header: 'Graveyard Keeper 2',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2026',
    },
    {
      childKey: 4,
      image: '/Games/Mina.png',
      header: 'Mina the Hollower',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.german) / $t(general:language.russian) / $t(general:language.portuguese-brazil) / $t(general:language.italian) / $t(general:language.korean) / $t(general:language.simplified-chinese) / $t(general:language.traditional-chinese)'})}</p>,
      meta: '2026',
    },
    {
      childKey: 5,
      image: '/Games/Unrailed2.png',
      header: 'Unrailed 2: Back on Track',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.latam) / $t(general:language.russian) / $t(general:language.portuguese-brazil) / $t(general:language.polish) / $t(general:language.korean) / $t(general:language.simplified-chinese) / $t(general:language.traditional-chinese) / $t(general:language.japanese)'})}</p>,
      meta: '2026',
    },
    {
      childKey: 8,
      image: '/Games/WildWoods.png',
      header: 'Wild Woods',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.latam) / $t(general:language.portuguese-brazil) / $t(general:language.polish) / $t(general:language.korean) / $t(general:language.czech)'})}</p>,
      meta: '2026',
    },
    {
      childKey: 10,
      image: '/Games/CashCleaner.png',
      header: 'Cash Cleaner Simulator',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2025',
    },
    {
      childKey: 12,
      image: '/Games/Asylum.png',
      header: 'Asylum',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2025',
    },        
    {
      childKey: 15,
      image: '/Games/SlenderThreads.png',
      header: 'Slender Threads',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2025',
    },
    {
      childKey: 16,
      image: '/Games/TerrysOG.png',
      header: 'Terry\'s Other Games',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2025',
    },
    {
      childKey: 18,
      image: '/Games/Dustborn.png',
      header: 'Dustborn',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.korean) / $t(general:language.spanish) / $t(general:language.latam) / $t(general:language.italian) / $t(general:language.portuguese-brazil) / $t(general:language.russian) / $t(general:language.simplified-chinese) / $t(general:language.polish) / $t(general:language.japanese)'})}</p>,
      meta: '2024',
    },
    {
      childKey: 21,
      image: '/Games/Bloomtown.png',
      header: 'Bloomtown: A Different Story',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2024',
    },    
    {
      childKey: 23,
      image: '/Games/REVEIL.png',
      header: 'REVEIL',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.korean) / $t(general:language.spanish) / $t(general:language.latam) / $t(general:language.polish) / $t(general:language.portuguese-brazil)'})}</p>,
      meta: '2024',
    },    
    {
      childKey: 24,
      image: '/Games/Emberlands.png',
      header: 'Into the Emberlands',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.korean)'})}</p>,
      meta: '2024',
    },    
    {
      childKey: 25,
      image: '/Games/FlingToTheFinish.png',
      header: 'Fling To The Finish',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.spanish) / $t(general:language.latam) / $t(general:language.portuguese-brazil) / $t(general:language.polish)'})}</p>,
      meta: '2024',
    },
    {
      childKey: 26,
      image: '/Games/ShGamb.png',
      header: 'Shadow Gambit: The Cursed Crew (+ DLC)',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.korean) / $t(general:language.spanish) / $t(general:language.italian) / $t(general:language.portuguese-brazil) / $t(general:language.russian) / $t(general:language.simplified-chinese) / $t(general:language.traditional-chinese) / $t(general:language.japanese) / $t(general:language.polish) / $t(general:language.turkish)'})}</p>,
      meta: '2023',
    },
    {
      childKey: 28,
      image: '/Games/Tintin.png',
      header: 'Tintin - Cigars of the Pharaoh',
      description: '',
      content: <p>{t('french-translation')} + {t('french-studio')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.spanish) / $t(general:language.italian) / $t(general:language.polish) / $t(general:language.dutch) / $t(general:language.portuguese-brazil) / $t(general:language.russian)'})}</p>,
      meta: '2023',
    },    
    {
      childKey: 30,
      image: '/Games/PunchClub2.png',
      header: 'Punch Club 2: Fast Forward (+ DLC)',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2023',
    },        
    {
      childKey: 33,
      image: '/Games/LifeOfDelta.png',
      header: 'Life of Delta',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish)'})}</p>,
      meta: '2023',
    },       
    {
      childKey: 34,
      image: '/Games/Nobodies2.png',
      header: 'Nobodies: After Death',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2023',
    },     
    {
      childKey: 35,
      image: '/Games/Gollum.png',
      header: 'The Lord of the Rings: Gollum',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish)'})}</p>,
      meta: '2023',
    },
    {
      childKey: 36,
      image: '/Games/Jester.png',
      header: 'Once Upon A Jester',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2023',
    },     
    {
      childKey: 37,
      image: '/Games/SKDig.png',
      header: 'Shovel Knight Dig (+ 3 DLCs)',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.korean) / $t(general:language.spanish) / $t(general:language.italian) / $t(general:language.portuguese-brazil) / $t(general:language.russian) / $t(general:language.simplified-chinese) / $t(general:language.traditional-chinese)'})}</p>,
      meta: '2023',
    },
    {
      childKey: 38,
      image: '/Games/Syberia4.png',
      header: 'Syberia - The World Before',
      description: '',
      content: <p>{t('french-translation')} + {t('french-studio')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.spanish) / $t(general:language.italian) / $t(general:language.portuguese-brazil)'})}</p>,
      meta: '2022',
    },
    {
      childKey: 39,
      image: '/Games/GLBurger.png',
      header: 'Godlike Burger',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.latam) / $t(general:language.portuguese-brazil) / $t(general:language.polish)'})}</p>,
      meta: '2022',
    },
    {
      childKey: 40,
      image: '/Games/Vertigo.png',
      header: 'Alfred Hitchcock Vertigo',
      description: '',
      content: <p>{t('french-translation')} + {t('french-studio')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.spanish) / $t(general:language.italian)'})}</p>,
      meta: '2021',
    },
    {
      childKey: 42,
      image: '/Games/SKPocket.png',
      header: 'Shovel Knight Pocket Dungeon (+ 4 DLCs)',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.korean) / $t(general:language.spanish) / $t(general:language.italian) / $t(general:language.portuguese-brazil) / $t(general:language.russian) / $t(general:language.simplified-chinese) / $t(general:language.traditional-chinese)'})}</p>,
      meta: '2021',
    },
    {
      childKey: 44,
      image: '/Games/STAiko.png',
      header: 'Shadow Tactics - Aiko\'s Choice',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.spanish) / $t(general:language.portuguese-brazil) / $t(general:language.polish)'})}</p>,
      meta: '2021',
    },
    {
      childKey: 46,
      image: '/Games/CyberShadow.png',
      header: 'Cyber Shadow',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.korean) / $t(general:language.spanish) / $t(general:language.italian) / $t(general:language.portuguese-brazil) / $t(general:language.russian) / $t(general:language.simplified-chinese) / $t(general:language.traditional-chinese)'})}</p>,
      meta: '2021',
    },
	  {
      childKey: 48,
      image: '/Games/RebelGalaxyOutlaw.png',
      header: 'Rebel Galaxy Outlaw',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2019 - 2020',
    },
    {
      childKey: 50,
      image: '/Games/Partisans1941.png',
      header: 'Partisans 1941 (+ DLC)',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.korean) / $t(general:language.spanish) / $t(general:language.latam) / $t(general:language.polish)'})}</p>,
      meta: '2020',
    },
    {
      childKey: 55,
      image: '/Games/ShovelKnightKingOfCard.png',
      header: 'Shovel Knight: King of Cards',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.spanish) / $t(general:language.italian) / $t(general:language.portuguese-brazil) / $t(general:language.russian)'})}</p>,
      meta: '2019 - 2020',
    },
    {
      childKey: 58,
      image: '/Games/CryoFall.png',
      header: 'CryoFall',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.polish) / $t(general:language.portuguese-brazil)'})}</p>,
      meta: '2019 - 2020',
    },
    {
      childKey: 60,
      image: '/Games/Unrailed.png',
      header: 'Unrailed!',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.polish) / $t(general:language.portuguese-brazil)'})}</p>,
      meta: '2019 - 2020',
    },
    {
      childKey: 65,
      image: '/Games/DiceyDungeons.png',
      header: 'Dicey Dungeons',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2019',
    },
    {
      childKey: 70,
      image: '/Games/Blacksad.png',
      header: 'Blacksad',
      description: '',
      content: <p>{t('french-translation')} + {t('french-studio')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.italian) / $t(general:language.dutch)'})}</p>,
      meta: '2019',
    },
    {
      childKey: 80,
      image: '/Games/Draugen.png',
      header: 'Draugen',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.japanese) / $t(general:language.russian) / $t(general:language.simplified-chinese) / $t(general:language.spanish)'})}</p>,
      meta: '2019',
    },
    {
      childKey: 90,
      image: '/Games/SwagAndSorcery.png',
      header: 'Swag & Sorcery',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2019',
    },
    {
      childKey: 100,
      image: '/Games/TrainValley2.png',
      header: 'Train Valley 2',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.portuguese-brazil) / $t(general:language.italian) / $t(general:language.spanish)'})}</p>,
      meta: '2019',
    },
    {
      childKey: 110,
      image: '/Games/Nobodies.png',
      header: 'Nobodies',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2019',
    },
    {
      childKey: 120,
      image: '/Games/FelixTheReaper.png',
      header: 'Felix The Reaper',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.portuguese-brazil) / $t(general:language.polish) / $t(general:language.spanish)'})}</p>,
      meta: '2019',
    },
    {
      childKey: 130,
      image: '/Games/Eastshade.png',
      header: 'Eastshade',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2019',
    },
    {
      childKey: 140,
      image: '/Games/RebelCops.png',
      header: 'Rebel Cops',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2019',
    },
    {
      childKey: 150,
      image: '/Games/ObraDinn.png',
      header: 'Return of the Obra Dinn',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2018',
    },
    {
      childKey: 160,
      image: '/Games/GraveyardKeeper.png',
      header: 'Graveyard Keeper',
      description: '',
      content: <p>{t('french-translation')}</p>,
      meta: '2018',
    },
    {
      childKey: 170,
      image: '/Games/TheFallPart2Unbound.png',
      header: 'The Fall Part 2: Unbound',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.german) / $t(general:language.spanish) / $t(general:language.italian)'})}</p>,
      meta: '2018',
    },
	  {
      childKey: 180,
      image: '/Games/StateOfMind.png',
      header: 'State of Mind',
      description: '',
      content: <p>{t('french-translation')}<br/>{t('translation-coordination', {'languages': '$t(general:language.spanish) / $t(general:language.portuguese-brazil)'})}</p>,
      meta: '2018',
    },
  ]
  let orderedItems = items.sort((a, b) => a.childKey > b.childKey);

  return (
    <Item.Group items={orderedItems} relaxed divided />
  );
}

export default Recent;
